import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-right\"><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M15.5 15.5l4-4-4-4M4 11.5h15\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol